import { AnyAction } from 'redux';
import { SagaIterator } from 'redux-saga';
import { call, put, takeLatest } from 'redux-saga/effects';
import { getSepaPaymentDetails, getSepaPayments } from 'src/api/sepa-payments';
import {
    FETCH_SEPA_PAYMENTS,
    FETCH_SEPA_PAYMENT_DETAILS,
    requestSepaPaymentDetails,
    requestSepaPaymentDetailsFailure,
    requestSepaPaymentDetailsSuccess,
    requestSepaPayments,
    requestSepaPaymentsFailure,
    requestSepaPaymentsSuccess,
} from './actions';

function* fetchSepaPaymentsSaga(action: AnyAction): SagaIterator {
    yield put(requestSepaPayments());

    const { error, response } = yield call(getSepaPayments, action.pageable, action.filter);

    if (error) {
        yield put(requestSepaPaymentsFailure(error));
    } else {
        yield put(requestSepaPaymentsSuccess(response));
    }
}

export function* generateFetchSepaPaymentsWatcher() {
    yield takeLatest(FETCH_SEPA_PAYMENTS, fetchSepaPaymentsSaga);
}

function* fetchSepaPaymentDetailsSaga(action: AnyAction): SagaIterator {
    yield put(requestSepaPaymentDetails());

    const { error, response } = yield call(getSepaPaymentDetails, action.externalOrderId);

    if (error) {
        yield put(requestSepaPaymentDetailsFailure(error));
    } else {
        yield put(requestSepaPaymentDetailsSuccess(response));
    }
}

export function* generateFetchSepaPaymentDetailsWatcher() {
    yield takeLatest(FETCH_SEPA_PAYMENT_DETAILS, fetchSepaPaymentDetailsSaga);
}
